<template>
  <l-modal
    :showing="showing"
    text="Sampling Points"
    icon="edit"
    color="bg-orange-500"
    @close="close"
  >
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Media Monitored</b>
          <br />
          <l-select
            v-model="editObj.media_monitored"
            class="text-xs"
            :data="mediavalues"
            :multiple="false"
          >
            <l-option
              v-for="i in mediavalues"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Station Id</b>
          <br />
          <l-select v-model="editObj.station_id" class="text-xs" :data="stations" :multiple="false">
            <l-option
              v-for="i in stations"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Measurement Regime</b>
          <br />
          <l-select
            v-model="editObj.measurement_regime"
            class="text-xs"
            :data="measurementregimes"
            :multiple="false"
          >
            <l-option
              v-for="i in measurementregimes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Mobile</b>
          <br />
          <l-input
            placeholder="Enter 'Mobile' ('true' or 'false')"
            v-model="editObj.mobile"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Assessment Type</b>
          <br />
          <l-select
            v-model="editObj.assessment_type"
            class="text-xs"
            :data="assessmenttypes"
            :multiple="false"
          >
            <l-option
              v-for="i in assessmenttypes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Station Classification</b>
          <br />
          <l-select
            v-model="editObj.station_classification"
            class="text-xs"
            :data="stationclassifications"
            :multiple="false"
          >
            <l-option
              v-for="i in stationclassifications"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Used Aqd</b>
          <br />
          <l-input
            placeholder="Enter 'Used Aqd' (optional) ('true' or 'false')"
            v-model="editObj.used_aqd"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Main Emission Sources</b>
          <br />
          <l-input
            placeholder="Enter 'Main Emission Sources' (optional) (text)"
            v-model="editObj.main_emission_sources"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Traffic Emissions</b>
          <br />
          <l-input
            placeholder="Enter 'Traffic Emissions' (optional) (text)"
            v-model="editObj.traffic_emissions"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Heating Emissions</b>
          <br />
          <l-input
            placeholder="Enter 'Heating Emissions' (optional) (text)"
            v-model="editObj.heating_emissions"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Industrial Emissions</b>
          <br />
          <l-input
            placeholder="Enter 'Industrial Emissions' (optional) (whole number)"
            v-model="editObj.industrial_emissions"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Distance Source</b>
          <br />
          <l-input
            placeholder="Enter 'Distance Source' (optional) (whole number)"
            v-model="editObj.distance_source"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Change Aei Stations</b>
          <br />
          <l-input
            placeholder="Enter 'Change Aei Stations' (optional) (text)"
            v-model="editObj.change_aei_stations"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Begin Position</b>
          <br />
          <l-input
            placeholder="YYYY-MM-DDTHH:mm:ss+hh:00"
            v-model="editObj.begin_position"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>End Position</b>
          <br />
          <l-input
            placeholder="YYYY-MM-DDTHH:mm:ss+hh:00 (optional)"
            v-model="editObj.end_position"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: [
    "showing",
    "samplingPoints",
    "mediavalues",
    "measurementregimes",
    "assessmenttypes",
    "stationclassifications",
    "stations",
    "selected",
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.selected);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      const mv = this.mediavalues.find(
        r => r.value == this.editObj.media_monitored
      );
      this.editObj.media_monitored_name = mv.label;
      const mr = this.measurementregimes.find(
        r => r.value == this.editObj.measurement_regime
      );
      this.editObj.measurement_regime_name = mr.label;
      const at = this.assessmenttypes.find(
        r => r.value == this.editObj.assessment_type
      );
      this.editObj.assessment_type_name = at.label;
      const sc = this.stationclassifications.find(
        r => r.value == this.editObj.station_classification
      );
      this.editObj.station_classification_name = sc.label;
      const s = this.stations.find(r => r.value == this.editObj.station_id);
      this.editObj.station = s.label;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>